import React from "react";
import {
    Heading,
    Paragraph,
    OrderedList,
    ListItem
} from "@piggybank/core";
import { useTranslation } from "react-i18next";

const CreditCardTCs = () => {
    const { t } = useTranslation();

    return (
        <>
            <Heading level={2} accentBar>{t('ICO.CREDIT.TC')}</Heading>
            <Paragraph>{t('ICO.CREDIT.TC_DESC1')}</Paragraph>
            <Paragraph>{t('ICO.CREDIT.TC_DESC2')}</Paragraph>
            <Paragraph>{t('ICO.CREDIT.TC_A')}</Paragraph>
            <OrderedList type="lower-alpha">
                <ListItem>
                    <Paragraph>{t('ICO.CREDIT.TC_B')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_B_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_B_2')}</ListItem>
                    </OrderedList>
                    <Paragraph>{t('ICO.CREDIT.TC_B_3')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_B_4')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_B_5')}</ListItem>
                    </OrderedList>
                </ListItem>
                <ListItem>
                    <Paragraph>{t('ICO.CREDIT.TC_C')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_C_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_C_2')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_C_3')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_C_4')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_C_5')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_C_6')}</ListItem>
                    </OrderedList>
                    <Paragraph>{t('ICO.CREDIT.TC_C_7')}</Paragraph>
                    <Paragraph>{t('ICO.CREDIT.TC_C_8')}</Paragraph>
                </ListItem>
                <ListItem><Paragraph dangerouslySetInnerHTML={{ __html: t('ICO.CREDIT.TC_D') }}/></ListItem>
                <ListItem>{t('ICO.CREDIT.TC_E')}</ListItem>
                <ListItem>{t('ICO.CREDIT.TC_F')}</ListItem>
                <ListItem>
                    <Paragraph> {t('ICO.CREDIT.TC_G')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_G_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_G_2')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_G_3')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_G_4')}</ListItem>
                    </OrderedList>
                    <Paragraph>{t('ICO.CREDIT.TC_G_5')}</Paragraph>
                </ListItem>
                <ListItem>{t('ICO.CREDIT.TC_H')}</ListItem>
                <ListItem>{t('ICO.CREDIT.TC_I')}</ListItem>
                <ListItem>
                    <Paragraph>{t('ICO.CREDIT.TC_J')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_J_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_J_2')}</ListItem>
                    </OrderedList>
                </ListItem>
                <ListItem>
                    <Paragraph>{t('ICO.CREDIT.TC_K')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_K_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_K_2')}</ListItem>
                    </OrderedList>
                </ListItem>
                <ListItem>{t('ICO.CREDIT.TC_L')}</ListItem>
                <ListItem>{t('ICO.CREDIT.TC_M')}</ListItem>
                <ListItem>{t('ICO.CREDIT.TC_N')}</ListItem>
                <ListItem>{t('ICO.CREDIT.TC_O')}</ListItem>
                <ListItem>{t('ICO.CREDIT.TC_P')}</ListItem>
                <ListItem>
                    <Paragraph>{t('ICO.CREDIT.TC_Q')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_Q_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_Q_2')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_Q_3')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_Q_4')}</ListItem>
                    </OrderedList>
                    <OrderedList type="lower-roman" style={{ 'paddingLeft': '20px' }}>
                        <ListItem>{t('ICO.CREDIT.TC_Q_6')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_Q_7')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_Q_8')}</ListItem>
                    </OrderedList>
                </ListItem>
                <ListItem>
                    <Paragraph>{t('ICO.CREDIT.TC_R')}</Paragraph>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_R_1')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_R_2')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_R_3')}</ListItem>
                    </OrderedList>
                    <OrderedList type="lower-roman" style={{ 'paddingLeft': '20px' }}>
                        <ListItem>{t('ICO.CREDIT.TC_R_4')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_R_5')}</ListItem>
                        <ListItem>{t('ICO.CREDIT.TC_R_6')}</ListItem>
                    </OrderedList>
                    <OrderedList type="lower-roman">
                        <ListItem>{t('ICO.CREDIT.TC_R_7')}</ListItem>
                    </OrderedList>
                    <Paragraph>{t('ICO.CREDIT.TC_R_8')}</Paragraph>
                </ListItem>
            </OrderedList>
            <Paragraph>{t('ICO.CREDIT.TC_DEF_DATE')}</Paragraph>
        </>
    )
}

export default CreditCardTCs;

